import { memo } from "react";
import { Button, Modal } from "antd";
import IntlMessages from "../Message/IntlMessages";
import DangerousMessage from "components/Message/DangerousMessage";
import { useDispatch } from "react-redux";
import { delay } from "utils/time-util";

const PWMRegisterWaitApproved = ({ close, actions, state, ...modalProps }) => {
  const dispatch = useDispatch();
  const acceptBtnMessageId = state?.acceptMessageId ?? "global.close";

  async function onAccept() {
    close();
    if (actions?.onAccept) actions.onAccept();
    if (actions?.acceptAction) {
      const _actions = Array.isArray(actions.acceptAction) ? actions.acceptAction : [actions.acceptAction];
      for (const action of _actions) {
        dispatch(action);
        await delay(0.3);
      }
    }
  }

  function onClose() {
    close();
    if (actions?.onClose) actions.onClose();
  }

  function convertEmailTextToLink(message) {
    const emailRegex = /([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g;
    return message.split(emailRegex).map((message, index) => {
      return (
        <span key={index}>{emailRegex.test(message) ? <a href={`mailto:${message}`}>{message}</a> : message}</span>
      );
    });
  }

  function renderPartMessage(message) {
    return typeof msg === "string" ? (
      <DangerousMessage.Span
        id="register.body.message"
        className="custom-message-1"
        html={message}
      ></DangerousMessage.Span>
    ) : (
      message
    );
  }

  return (
    <Modal {...modalProps} maskClosable onCancel={onClose}>
      {modalProps.visible && (
        <div className="mnc-modal-disclaimer">
          <div className="modal-mnc-head">
            <h5 className="m-0">
              <IntlMessages id="global.krungthai.pwm" />
            </h5>
            <Button className="btn button-ktb-close" onClick={close}>
              <i className="feather-icon icon-x"></i>{" "}
            </Button>
          </div>
          <div className="text-center modal-mnc-body">
            {state.showIcon ? (
              <div className="bg-icon">
                <i className="feather-icon icon-check"></i>
              </div>
            ) : null}
            {state.messageCode && <IntlMessages id={state.messageCode} />}
            {state.message && convertEmailTextToLink(state.message).map(renderPartMessage)}
            {state.messages &&
              state.messages.map(convertEmailTextToLink).map((partMessages) => partMessages.map(renderPartMessage))}
          </div>

          <div className="modal-mnc-footer">
            <div className="row justify-content-center">
              <div className="col-6">
                <div className="d-grid">
                  <Button data-accept-btn type="primary" className="btn button-ktb-main" onClick={onAccept}>
                    <IntlMessages id={acceptBtnMessageId} />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default memo(PWMRegisterWaitApproved);
